import { ProductComponent } from '@theme/view-event-elements';

// Keep native product-view analytics; purchases are configured on the product page.
if (!customElements.get('grit-product-card')) {
  customElements.define('grit-product-card', class extends ProductComponent {});
}
